import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import PinLock from "@/pages/PinLock";
import Dashboard from "@/pages/Dashboard";

const TOASTER_OPTIONS = {
  style: {
    background: "rgba(15, 23, 42, 0.85)",
    backdropFilter: "blur(18px)",
    border: "1px solid rgba(255,255,255,0.18)",
    color: "#f8fafc",
  },
};

function RequireAuth({ children }) {
  const token = localStorage.getItem("session_token");
  if (!token) return <Navigate to="/" replace />;
  return children;
}

function App() {
  const [ready, setReady] = useState(false);
  useEffect(() => setReady(true), []);
  if (!ready) return null;
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PinLock />} />
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        duration={1600}
        toastOptions={TOASTER_OPTIONS}
      />
    </div>
  );
}

export default App;
